module.exports = __webpack_public_path__ + "img/arrow-left.ddff60fb.svg";